// @flow
import * as React from 'react';
import './navigation.scss'
import {useRef} from "react";
import * as Categories from "../../../enums/categories";

type Props = {
	currentCategory: number
	showCategory: (e: number) => void
};
export const Navigation = ({showCategory, currentCategory}: Props) => {
	
	const navigation = useRef(null)
	
	/*
	// WE ARE NOT ALLOWING CHANGING OF THE NOMINATION CATEGORY FOR NOW
	const selectedCategory = (index: number) => {
		const currentChildrenElement = [...navigation.current.children];
		const activeComponent = currentChildrenElement.filter((n: any) => n.className === 'active')
		activeComponent[0].className = ''
		currentChildrenElement[index].className = 'active'
		showCategory(index)
	}
	*/
	
	const renderCategories = Object.values(Categories.CategoryData).map((item: any, i: number) => {
		if (i === 0) {
			// 2023 we skip intro screen
			return;
		}
		return <li key={i} onClick={() => {} /* () => selectedCategory(item.key) */} value={item.key}
		           className={(item.key) === currentCategory ? 'active' : ''}>{item.title}</li>
	});
	
	return (
		<div className="navigation">
			<ul ref={navigation}>
				{renderCategories}
			</ul>
		</div>
	);
};
